<form [formGroup]="formGroup" *ngIf="companyBonds">
  <div *ngIf="companyBonds?.length && companyBondDisabled && importerIdentifierQual && importerIdentifier" class="text-warning">
    {{
      "FORM_ERROR.COMPANY_BONDS_DISABLED"
        | translate
          : {
              companyIdentifier:
                "(" + (company.identifierQualifier | identifierQualifier | translate) + " " + (company.identifier | identifier) + ")",
              importerIdentifier:
                "(" + (importerIdentifierQual | identifierQualifier | translate) + " " + (importerIdentifier | identifier) + ")"
            }
    }}
  </div>
  <div
    *ngFor="let bond of companyBonds; let index = index"
    class="card card-step"
    [ngClass]="{ 'is-selected': selectedBondIndex.value === index, disabled: companyBondDisabled, 'is-desktop': isDesktop }"
  >
    <div class="card-header">
      <app-radio-button
        [control]="selectedBondIndex"
        [id]="'bond-' + bond.referenceNumber"
        [label]="bondLabel(bond, index)"
        [value]="index"
        [disabled]="companyBondDisabled"
      ></app-radio-button>
    </div>
    <div class="card-body" *ngIf="showBondBody(bond, index)">
      <div class="container">
        <div class="row">
          <div
            *ngIf="(bond.type === enumBondType.SINGLE_TRANSACTION || showSuretyCodeForContinuousBond) && bond.referenceNumber"
            class="col-12 col-lg-6 form-row"
          >
            <div class="col-label">{{ "LABELS.BOND_REFERENCE_NUMBER" | translate }}</div>
            <div class="col-value">{{ bond.referenceNumber }}</div>
          </div>
          <div *ngIf="formGroup.get('bondAmount')" class="col-12 col-lg-6 form-row">
            <div class="col-label">{{ "BOND_COVERAGE" | translate }}</div>
            <div class="col-value">{{ bond.amount | currency : "USD" : "symbol" : "1.2-2" }}</div>
          </div>
          <div *ngIf="bond.effectiveDate && bond.type === enumBondType.SINGLE_TRANSACTION" class="col-12 col-lg-6 form-row">
            <div class="col-label">{{ "LABELS.EFFECTIVE_DATE_TIME" | translate }}</div>
            <div class="col-value">{{ bond.effectiveDate | customDateByUtc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="purchaseBondForm" [ngTemplateOutlet]="purchaseSingleBond"></ng-container>

  <div class="card card-step" [ngClass]="{ 'is-selected': selectedBondIndex.value === userContinuousBondIndex, 'is-desktop': isDesktop }">
    <div class="card-header">
      <app-radio-button
        [control]="selectedBondIndex"
        [id]="'custom_continuous_bond'"
        [label]="'FORM_LABEL.ADD_EXISTING_CONTINUOUS_BOND'"
        [value]="userContinuousBondIndex"
        [disabled]="!canEdit"
      ></app-radio-button>
    </div>
    <div class="card-body" *ngIf="selectedBondIndex.value === userContinuousBondIndex">
      <div class="container">
        <app-bond-edit-form
          [errors]="errors"
          [formGroup]="formGroup"
          [showSuretyCodeForContinuousBond]="showSuretyCodeForContinuousBond"
          [showRefNumberForContinuousBond]="showRefNumberForContinuousBond"
          [isDesktop]="isDesktop"
          (selectCustomContinuousBond)="onSelectCustomContinuousBond()"
        ></app-bond-edit-form>
      </div>
    </div>
  </div>
</form>

<custom-modal [(open)]="isOpenPriceModal" [header]="'SINGLE_BOND_PURCHASE.PRICE.HEADER'">
  <div>
    <div>
      {{ "SINGLE_BOND_PURCHASE.PRICE.DESCRIPTION" | translate }}
    </div>
    <div>
      {{ "SINGLE_BOND_PURCHASE.PRICE.DESCRIPTION_1" | translate }}
    </div>
    <table class="mt-2">
      <tbody>
        <tr>
          <td class="pr-2">{{ "SINGLE_BOND_PURCHASE.PRICE.ISF" | translate }}</td>
          <td class="font-weight-500">
            {{ singleISFBondPrice | currency : DEFAULT_CURRENCY_CODE : "$" : "1.0-2" }}
          </td>
        </tr>
        <tr>
          <td class="pr-2">{{ "SINGLE_BOND_PURCHASE.PRICE.ENTRY" | translate }}</td>
          <td class="font-weight-500">
            {{ singleESBondPrice | currency : DEFAULT_CURRENCY_CODE : "$" : "1.0-2" }}
          </td>
        </tr>
        <tr>
          <td [colSpan]="2" class="helper">
            {{
              "SINGLE_BOND_PURCHASE.PRICE.ADDITIONAL"
                | translate
                  : {
                      cost: (additionToESBondPrice | currency : DEFAULT_CURRENCY_CODE : "$" : "1.0-2")
                    }
            }}
          </td>
        </tr>
        <tr>
          <td [colSpan]="2" class="pr-2 small font-weight-500">{{ "SINGLE_BOND_PURCHASE.PRICE.BOND_VALUE" | translate }}</td>
        </tr>
        <tr>
          <td class="pl-3 pr-2 small">{{ "SINGLE_BOND_PURCHASE.PRICE.PGA_BOND" | translate }}</td>
          <td class="font-weight-500 small">
            {{ "SINGLE_BOND_PURCHASE.PRICE.PGA_BOND_VALUE" | translate }}
          </td>
        </tr>
        <tr>
          <td class="pl-3 pr-2 small">{{ "SINGLE_BOND_PURCHASE.PRICE.NON_PGA_BOND" | translate }}</td>
          <td class="font-weight-500 small">
            {{ "SINGLE_BOND_PURCHASE.PRICE.NON_PGA_BOND_VALUE" | translate }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mt-2 font-weight-500">{{ "SINGLE_BOND_PURCHASE.PRICE.BEST_VALUE" | translate }}:</div>
    <div
      [innerHTML]="
        'SINGLE_BOND_PURCHASE.PRICE.CONTINUOUS_CUSTOMS_BOND'
          | translate : { val: (continuousBondPrice | currency : DEFAULT_CURRENCY_CODE : '$' : '1.0-2') }
      "
    ></div>
  </div>
  <button footer-action type="button" class="btn btn-secondary" (click)="closePriceModal()">
    {{ "BUTTON.CLOSE" | translate }}
  </button>
</custom-modal>

<ng-template #purchaseSingleBond>
  <div class="card card-step" [ngClass]="{ 'is-selected': isSelectedPurchase, 'is-desktop': isDesktop }">
    <div class="card-header">
      <app-radio-button
        [control]="selectedBondIndex"
        [id]="'purchase-bond'"
        [label]="(isEntrySummary ? 'SINGLE_BOND_PURCHASE.FORM_LABEL_ES' : 'SINGLE_BOND_PURCHASE.FORM_LABEL_ISF') | translate"
        [value]="bondPurchaseIndex"
        [disabled]="!canEdit"
      ></app-radio-button>
    </div>
    <div *ngIf="isSelectedPurchase" class="card-body">
      <div class="container">
        <div class="form-row">
          <div
            class="col-12"
            [innerHTML]="(isEntrySummary ? 'SINGLE_BOND_PURCHASE.DESCRIPTION' : 'SINGLE_BOND_PURCHASE.DESCRIPTION_ISF_HEADER') | translate"
          ></div>
          <div *ngIf="bondPurchaseAdditionalRemarks" class="col-12 mb-2" [innerHTML]="bondPurchaseAdditionalRemarks | translate"></div>
          <div class="col-12 mb-2">
            <p class="text-hint mt-1 mb-0" *ngIf="isEntrySummary && !isManagement" [ngClass]="{ 'mb-0': !isEntrySummary }">
              <span
                [innerHTML]="
                  'SINGLE_BOND_PURCHASE.NOTE'
                    | translate
                      : {
                          cost: (singleESBondPrice | currency : DEFAULT_CURRENCY_CODE : '$' : '1.0-2'),
                          extraCost: (additionToESBondPrice | currency : DEFAULT_CURRENCY_CODE : '$' : '1.0-2')
                        }
                "
              ></span>
              <a href="/price" (click)="openPriceModal($event)">{{ "BUTTON.SEE_MORE_PRICING_DETAILS" | translate }}</a>
            </p>
          </div>
          <div class="col-12" *ngIf="purchaseBondForm.get('amount')">
            <app-control-wrapper [control]="purchaseBondForm.get('amount')" [errors]="errors.amount">
              <label for="purchaseBondAmount" control-label>{{ "LABELS.AMOUNT" | translate }}</label>
              <div control-wrapper class="currency-form-container">
                <input
                  type="text"
                  [formControl]="purchaseBondForm.get('amount')"
                  class="form-control currency"
                  id="purchaseBondAmount"
                  name="bondAmount"
                  inputmode="numeric"
                  [pattern]="currencyInputMap.pattern"
                  [mask]="currencyInputMap.mask"
                  [appMaskErrorTooltip]="currencyInputMap.maskErrorTooltip"
                  [thousandSeparator]="currencyInputMap.thousandSeparator"
                />
                <div class="form-control currency-box">{{ DEFAULT_CURRENCY_CODE }}</div>
              </div>
            </app-control-wrapper>
          </div>

          <div class="col-12" *ngIf="isEntrySummary">
            <div class="bond-notification">
              <div class="bond-notification-card">
                <div class="bond-notification-card-text">
                  {{ "AFTER_YOU_WILL_FILE_ENTRY_HINT" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <auto-select
              [label]="'LABELS.ARRIVAL_PORT'"
              [bindLabel]="['code', 'description']"
              [bindOption]="['code', 'description']"
              [bindValue]="'code'"
              [initializeItems]="initPorts"
              [change]="getPorts()"
              [fc]="purchaseBondForm.get('portCode')"
              [id]="'portCode'"
              [errors]="errors?.portCode || defaultErrors"
              [dropdownPosition]="'top'"
              [helper]="'SINGLE_BOND_PURCHASE.DESCRIPTION_ISF_HELPER' | translate"
            ></auto-select>
          </div>

          <div class="col-12">
            <div class="bond-notification bond-notification-hint">
              <div class="bond-notification-card">
                <div class="bond-notification-card-icon">
                  <img src="assets/icons/icon_warning_blue_sm.svg" />
                </div>
                <div class="bond-notification-card-text">
                  {{ (isEntrySummary ? "YOU_CANT_USE_SINGLE_ISF_BOND" : "SINGLE_BOND_PURCHASE.DESCRIPTION_ISF_HINT") | translate }}
                </div>
              </div>

              <div class="bond-notification-line"></div>
            </div>

            <p class="mb-0" [innerHTML]="'SINGLE_BOND_PURCHASE.DESCRIPTION_ISF_FOOTER' | translate"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
